// eslint-disable-next-line import/no-cycle
import { ABRegistry } from './core/ABRegistry';

export { ABRegistry };
export const ABRegistryInstance = new ABRegistry();
